module.exports = __webpack_public_path__ + "media/activity-level/active-b30f5083.svg";